module.exports = {
  name: 'show1-infinite',
  waitForImages: true,
  settings: {
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '0',
    slidesToScroll: 1,
    dots: true,
    arrows: true
  },
}
